"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePipCount = void 0;
exports.getOppositePlayer = getOppositePlayer;
/**
 * Utility functions for creating boards and game states.
 */
var constants_1 = require("@/constants");
/**
 * Returns the opposite player color.
 * @param player The current player color (PLAYER_BLACK or PLAYER_WHITE)
 * @returns The opposite player color
 */
function getOppositePlayer(player) {
    return player === constants_1.PLAYER_BLACK ? constants_1.PLAYER_WHITE : constants_1.PLAYER_BLACK;
}
// Export pip counter utility
var pipCounter_1 = require("./pipCounter");
Object.defineProperty(exports, "calculatePipCount", { enumerable: true, get: function () { return pipCounter_1.calculatePipCount; } });
//# sourceMappingURL=index.js.map